export default "__VITE_ASSET__eqlhCkhz__"